import { COMMON_DOCUMENTS } from './documents';
export const GENERIC = {
    code: null,
    name: 'Other country',
    profileVersion: 1,
    readiness: 'legacy',
    timezone: 'UTC',
    weekend: [6, 0],
    firstDayOfWeek: 1,
    currency: { code: 'USD', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [],
    branchSubdivision: 'none',
    locales: {
        ui: ['en'],
        defaultUi: 'en',
        documentSecondary: null,
        secondaryOnTaxDocuments: 'off',
        secondaryOnClinicalDocuments: 'off',
        formatting: { en: 'en-GB' },
    },
    phone: { callingCode: '', trunkPrefix: null, nationalLengths: [], mobilePattern: '^\\d{6,15}$', example: '' },
    names: { parts: ['first', 'father', 'last'], labels: { father: 'Father / husband name' }, askLocalName: false },
    identity: {
        documents: [
            {
                type: 'pk_cnic',
                labelKey: 'identity.pk_cnic',
                label: 'CNIC',
                pattern: '^\\d{13}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'refuse',
                example: '35201-1234567-1',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'passport',
        autoDetect: false,
        capture: { hospital: 'optional', lab: 'hidden', pharmacy: 'hidden' },
        askNationality: false,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [],
    tax: [
        {
            code: 'none',
            effectiveFrom: '1900-01-01',
            registration: null,
            companyRegistrationLabelKey: null,
            companyRegistrationLabel: null,
            standardRatePct: null,
            serviceDefaultCategory: 'out_of_scope',
            productDefaultCategory: 'out_of_scope',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: null, mandatory: 'no', fromDate: null, appliesTo: [] },
    addOns: [],
    feeSplittingDefault: false,
};
//# sourceMappingURL=generic.js.map